module.exports = __webpack_public_path__ + "img/Enmascarar grupo 18@2x.3b946a9b.png";